import { useMemo } from 'react';

import { getDateFnsLocaleWithWeekStartsOnMonday, LanguageUtils } from '../utils/translations';

export function useLocaleForDatePicker() {
  return useMemo(() => {
    const appLocale = LanguageUtils.getAppLocaleWithFallback();
    return getDateFnsLocaleWithWeekStartsOnMonday(appLocale);
  }, []);
}
